export const pillars = [
  {
    id: "education",
    number: "01",
    title: "Education & workforce",
    description:
      "Build the knowledge and practical skills to participate in Africa’s economic future.",
    detail:
      "Financial literacy, a planned Trading Academy, and future professional development pathways for learners on the continent and across the diaspora.",
    status: "Academy interest registration",
    link: "/trading-academy",
    action: "Explore the academy",
    image: "/assets/images/site/svc001-800x600.jpg",
  },
  {
    id: "enterprise",
    number: "02",
    title: "Enterprise & advisory",
    description:
      "Turn ambition into a thoughtful plan for enterprise, family wealth, and cross-border collaboration.",
    detail:
      "Start a conversation about your goals, investor readiness, or a business idea. We will discuss the scope of support and any specialist input needed before an engagement.",
    status: "Inquiries welcome",
    link: "/advisory#consult",
    action: "Discuss your goals",
    image: "/assets/images/site/svc002-800x600.jpg",
  },
  {
    id: "partnerships",
    number: "03",
    title: "Capital & partnerships",
    description:
      "Connect people, expertise, and resources around shared African development priorities.",
    detail:
      "We welcome education and enterprise partners. Family office, private credit, and private equity pathways remain planned areas of work, subject to qualification and review.",
    status: "Partnership inquiries welcome",
    link: "/partnerships",
    action: "Explore collaboration",
    image: "/assets/images/site/svc007-800x600.jpg",
  },
];
